import {useEffect} from 'react';

import {useDispatch, useSelector} from 'react-redux';
import {getDashboardsConfigurationRequest} from '../redux/dashboardConfiguration/actions';
import {selectordashboardConfProp} from '../redux/dashboardConfiguration/selectors';

const useQuicksightConfiguration = () => {
    const dispatch =useDispatch();
    const confIsLoaded =useSelector(selectordashboardConfProp);
    useEffect(() => {
        !confIsLoaded && dispatch(getDashboardsConfigurationRequest());
        return;
    }, [confIsLoaded, dispatch]);
    return !!confIsLoaded;
};

export default useQuicksightConfiguration;
